import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutMva() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34879" id="para-quién-es" className="bg-background py-32 overflow-hidden text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="lg:col-span-7 flex flex-col gap-8">
            <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground tracking-tight">
              Gestión de documentos mexicanos a distancia para uso en el extranjero
            </h2>

            <div className="space-y-8 text-lg font-sans text-foreground/90 leading-relaxed">
              <div>
                <h3 className="text-xl font-default font-bold text-foreground mb-3 uppercase tracking-wide border-l-4 border-secondary pl-3">
                  CLARIDAD DESDE EL PRIMER PASO
                </h3>
                <p>
                  Ayudamos a mexicanos en España, Estados Unidos y otros países a gestionar apostillas y documentos mexicanos sin viajar a México, con requisitos claros, atención cercana y seguimiento durante el proceso.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-default font-bold text-foreground mb-3 uppercase tracking-wide border-l-4 border-secondary pl-3">
                  ACOMPAÑAMIENTO DOCUMENTAL EN CADA ETAPA
                </h3>
                <p>
                  Te orientamos en la gestión de actas mexicanas, Constancia de Antecedentes Penales Federales, títulos profesionales, poderes notariales y otros documentos para uso en el extranjero, según los requisitos de cada trámite.
                </p>
              </div>

              <div className="pt-6 border-t border-foreground/10">
                <p className="text-sm italic font-sans text-muted-foreground">Pensado para mexicanos en el extranjero que necesitan documentos de México sin necesidad de viajar.</p>
              </div>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-md text-base px-8">
                <Link to="#documentos">
                  Ver documentos que gestionamos <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            <div className="relative group">
              {}
              <div className="absolute top-2 left-2 w-full h-full bg-accent/40 rounded-xl z-0" aria-hidden="true" />

              {}
              <div className="relative z-10 border-4 border-muted bg-background rounded-xl overflow-hidden shadow-xl" aria-label="Representación de una familia mexicana y el Ángel de la Independencia, simbolizando la gestión de documentos en el extranjero">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596556/img/mexican_family_angel_new.png" alt="familia mexicana, ángel independencia, documentos extranjero" title="familia mexicana, ángel independencia, documentos extranjero" className="w-full h-auto object-cover aspect-[4/3] block" data-focal-point="face,documents,angel" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}